export const MODE_ENUMS = {
  DAY: 'days',
  MONTH: 'months',
  YEAR: 'years'
}
